export default __webpack_public_path__ + "static/media/gabig-banner-de.069ff793.webp";